import { Pipe, PipeTransform } from '@angular/core';

import { AliasMap } from 'src/app/shared/constants/alias';

@Pipe({
  name: 'alias',
})
export class AliasPipe implements PipeTransform {
  transform(value: any, localMap?: Record<string, string>): any {
    const key = value
      ?.toString()
      ?.toLowerCase();

    // Look through local alias map.
    if (localMap && localMap[key]) {
      return localMap[key];
    }

    // Look through the global alias map.
    return AliasMap[key] || value;
  }
}
